import React, { useState } from 'react';
import { TextField, Typography } from '@material-ui/core';
// eslint-disable-next-line import/no-named-as-default -- posthog-js re-exports its own default as a named `posthog` too
import posthog from 'posthog-js';
import { useDispatch } from 'react-redux';
import { DeprecatedModal, ModalCancelButton, ModalConfirmationButton, ModalTitle } from '../../common/DeprecatedModal';
import { renameEnvelope } from '../../store/envelopeManagement/actions';

interface IProps {
  envelopeId: string;
  envelopeName: string;
  close: () => void;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const RenameModal = (props: IProps) => {
  const dispatch = useDispatch();
  const { envelopeId, envelopeName, close } = props;
  const [newEnvelopeName, setNewEnvelopeName] = useState(envelopeName);

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const onClickSave = () => {
    posthog.capture('envelope_renamed');
    dispatch(renameEnvelope(envelopeId, newEnvelopeName));
    close();
  };

  const title = <ModalTitle>Edit Envelope</ModalTitle>;
  const content = (
    <>
      <Typography variant="overline" className="block w-full pb-4 mt-8">
        ENVELOPE NAME
      </Typography>
      <TextField
        data-spec="edit-envelope-name-input"
        variant="outlined"
        classes={{ root: 'w-full' }}
        inputProps={{ className: 'py-2 px-0' }}
        onChange={(e) => setNewEnvelopeName(e.target.value)}
        value={newEnvelopeName}
      />
    </>
  );
  const actionButtons = (
    <>
      <ModalCancelButton onClick={close} aria-label="cancel edit envelope name">
        Cancel
      </ModalCancelButton>
      <ModalConfirmationButton
        data-spec="edit-envelope-name-save"
        disabled={newEnvelopeName === envelopeName}
        onClick={onClickSave}
        aria-label="confirm edit envelope name"
      >
        Save
      </ModalConfirmationButton>
    </>
  );
  return <DeprecatedModal toggleModal={close} title={title} content={content} actionButtons={actionButtons} />;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default RenameModal;
